const Forms = [
    {
        id: 1,
        title: 'Calisivirus FIPImmun42',
        titleEn: 'Calisivirus FIPImmun42',
        slug: 'calisivirus-fipimmun42',
        link: '/assets/forms/Calisivirus-FIPImmun42.pdf',
        linkEn: "/assets/forms/en/Clinical-Use-of-FIPImmun42-in-Feline-Calicivirus-Infection.pdf",
        hasEnVersion: true,
        proImg: '/assets/images/pdf_icon.png'
    },
    {
        id: 2,
        title: "FIPV'nin N\u00f6rolojik Formunda FIPImmun42'nin Etkinli\u011fi",
        titleEn: 'Efficacy of FIPImmun42 in the Neurological Form of FIPV',
        slug: 'fipv-norolojik-form',
        link: "/assets/forms/FIPVnorolojik_formunda_immun42_etkinligi.pdf",
        hasEnVersion: false,
        proImg: '/assets/images/pdf_icon.png'
    },
    {
        id: 3,
        title: "FIP'te Alb\u00fcmin Globulin Oran\u0131 Vitanimal",
        titleEn: 'Albumin Globulin Ratio in FIP Vitanimal',
        slug: 'fip-albumin-globulin',
        link: "/assets/forms/FIP’te Albümin-Globulin Oranı_Vitanimal.pdf",
        linkEn: "/assets/forms/en/The-Albumin-to-Globulin-Ratio-in-FIP.pdf",
        hasEnVersion: true,
        proImg: '/assets/images/pdf_icon.png'
    },
    {
        id: 4,
        title: "FIP'te Serolojik ve Biyokimyasal Tan\u0131sal Yakla\u015f\u0131m Vitanimal",
        titleEn: 'Serological and Biochemical Diagnostic Approach in FIP Vitanimal',
        slug: 'fip-serolojik-tani',
        link: "/assets/forms/FIP’te Serolojik ve Biyokimyasal Tanısal Yaklaşım_Vitanimal.pdf",
        linkEn: "/assets/forms/en/Serological-and-Biochemical-Diagnostic-Approach-in-FIP.pdf",
        hasEnVersion: true,
        proImg: '/assets/images/pdf_icon.png'
    },
    {
        id: 5,
        title: "Feline Infectious Peritonitis'te (FIP) Zor Vakalar\u0131n Y\u00f6netimi Vitanimal",
        titleEn: 'Management of Difficult Cases in Feline Infectious Peritonitis (FIP) Vitanimal',
        slug: 'fip-zor-vakalar',
        link: "/assets/forms/Feline Infectious Peritonitis’te (FIP) Zor Vakaların Yönetimi_Vitanimal.pdf",
        linkEn: "/assets/forms/en/Challenging-and-Refractory-FIP-Cases _Vitanimal.pdf",
        hasEnVersion: true,
        proImg: '/assets/images/pdf_icon.png'
    },
    {
        id: 6,
        title: "Feline Infectious Peritonitis'te Yard\u0131mc\u0131-Destekleyici Tedavi Vitanimal",
        titleEn: 'Supportive Therapy in Feline Infectious Peritonitis Vitanimal',
        slug: 'fip-yardimci-tedavi',
        link: "/assets/forms/Feline Infectious Peritonitis’te Yardımcı-Destekleyici Tedavi_Vitanimal.pdf",
        linkEn: "/assets/forms/en/Supportive-and-Adjunctive-Therapy-in-FIP_Vitanimal.pdf",
        hasEnVersion: true,
        proImg: '/assets/images/pdf_icon.png'
    }
];

export default Forms;
